import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import { CART_STATE, ON_FETCH_SUCCESS, ON_FETCH_FAILURE, ON_INIT_CART, CLEAR_CART_STATE, FETCH_CARTS_SUCCESS, ADD_TO_CARTS_SUCCESS, MERGE_CARTS_SUCCESS, FETCH_CARTS_FAILURE, MERGE_CARTS_FAILURE, ADD_TO_CARTS_FAILURE } from '@nike/cart-constants';
import totalsReducer from './totals';
var cartReducer = function cartReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : CART_STATE;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  switch (action.type) {
    case ON_INIT_CART:
      return _objectSpread(_objectSpread({}, state), {}, {
        country: action.payload.country
      });
    case FETCH_CARTS_FAILURE:
    case MERGE_CARTS_FAILURE:
    case ADD_TO_CARTS_FAILURE:
    case ON_FETCH_FAILURE:
    case MERGE_CARTS_SUCCESS:
    case FETCH_CARTS_SUCCESS:
    case ADD_TO_CARTS_SUCCESS:
    case ON_FETCH_SUCCESS:
      {
        var _action$payload, _action$payload2, _action$payload$data, _action$payload3, _action$payload3$prom;
        var data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data;
        var newState = _objectSpread(_objectSpread(_objectSpread({}, state), (action === null || action === void 0 ? void 0 : (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.data) || state), {}, {
          errors: (_action$payload$data = action.payload.data) === null || _action$payload$data === void 0 ? void 0 : _action$payload$data.errors,
          totals: totalsReducer(state.totals, action)
        });
        if (data !== null && data !== void 0 && data.order) {
          newState.order = data.order;
        }
        if ((_action$payload3 = action.payload) !== null && _action$payload3 !== void 0 && (_action$payload3$prom = _action$payload3.promotionCodes) !== null && _action$payload3$prom !== void 0 && _action$payload3$prom.length) {
          newState.promotionCodes = action.payload.promotionCodes;
        }
        return newState;
      }
    case CLEAR_CART_STATE:
      return _objectSpread(_objectSpread({}, CART_STATE), {}, {
        country: state.country,
        currency: state.currency
      });
    default:
      return state;
  }
};
export default cartReducer;